import { render, staticRenderFns } from "./ExceptionReport.vue?vue&type=template&id=706f1a2c&"
import script from "./ExceptionReport.vue?vue&type=script&lang=js&"
export * from "./ExceptionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports